/**
 * @class User
 */
export default class User {
    /**
     * @param {Number}  id
     * @param {String}  login
     * @param {String}  barcode
     * @param {Boolean} local
     * @param {Boolean} isDeleted
     * @param {Boolean} canBeDeleted
     * @param {Boolean} canBeEdited
     * @param {Boolean} autoLogin
     * @param {Array}   groups
     */
    constructor(
        id,
        login,
        barcode = "",
        local = false,
        isDeleted = false,
        canBeDeleted = false,
        canBeEdited = false,
        autoLogin = false,
        groups = []
    ) {
        this._id = id;
        this._login = login;
        this._barcode = barcode;
        this._local = local;
        this._isDeleted = isDeleted;
        this._canBeDeleted = canBeDeleted;
        this._canBeEdited = canBeEdited;
        this._autoLogin = autoLogin;
        this._groups = groups;

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - User");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String}
     */
    get login() {
        return this._login;
    }

    /**
     * @param {String} login
     */
    set login(login) {
        this._login = login;
    }

    /**
     * @return {String}
     */
    get barcode() {
        return this._barcode;
    }

    /**
     * @param {String} barcode
     */
    set barcode(barcode) {
        this._barcode = barcode;
    }

    /**
     * @return {Boolean}
     */
    get local() {
        return this._local;
    }

    /**
     * @param {Boolean} local
     */
    set local(local) {
        this._local = local;
    }

    /**
     * @return {Boolean}
     */
    get isDeleted() {
        return this._isDeleted;
    }

    /**
     * @param {Boolean} isDeleted
     */
    set isDeleted(isDeleted) {
        this._isDeleted = isDeleted;
    }

    /**
     * @return {Boolean}
     */
    get canBeDeleted() {
        return this._canBeDeleted;
    }

    /**
     * @param {Boolean} canBeDeleted
     */
    set canBeDeleted(canBeDeleted) {
        this._canBeDeleted = canBeDeleted;
    }

    /**
     * @return {Boolean}
     */
    get canBeEdited() {
        return this._canBeEdited;
    }

    /**
     * @param {Boolean} canBeEdited
     */
    set canBeEdited(canBeEdited) {
        this._canBeEdited = canBeEdited;
    }

    /**
     * @return {Boolean}
     */
    get autoLogin() {
        return this._autoLogin;
    }

    /**
     * @param {Boolean} autoLogin
     */
    set autoLogin(autoLogin) {
        this._autoLogin = autoLogin;
    }

    /**
     * @return {Array}
     */
    get groups() {
        return this._groups;
    }

    /**
     * @param {Array} groups
     */
    set groups(groups) {
        this._groups = groups;
    }

    /**
     * @return {User}
     */
    clone = () => {
        return new User(
            this._id,
            this._login,
            this._barcode,
            this._local,
            this._isDeleted,
            this._canBeDeleted,
            this._canBeEdited,
            this._autoLogin,
            this._groups
        );
    };

    /**
     * @return {String}
     */
    toString() {
        return "User (" + this._id + ")";
    }
}
